import { useMemo, useRef } from 'react'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import s from './bg.module.scss'

export const CustomSlick = ({ background }) => {

  const img = useMemo(() => Array.isArray(background) ? background : [], [])

  const rootRef = useRef()

  livecloud.useCreate(()=>{
    if (window.screen.width < 800) {
      if (rootRef.current){
        let y = document.body.clientHeight
        rootRef.current.style.height = `${y}px`
      }
    }
  })

  return (
    <div className={`${s.root} bgSliderBox`}>
      <Slider
        dots={false}
        infinite
        autoplay={img.length > 1}
        autoplaySpeed={10000}
      >
        {
          img.map((pictureUrl, i) => (
            <div
              key={i}
              className={`${s.imgBox} bgSliderImgBox`}
            >
              <img src={`${livecloud.basename}${pictureUrl}`} ref={rootRef}/>
            </div>
          ))
        }
      </Slider>
    </div >
  )
}
